function addRankingBadges() {
  var rankingSection = Array.from(document.querySelectorAll('.section-resource-list')).find(function(s) {
    return s.querySelector('a[href*="ranking"]');
  });

  if (!rankingSection) return;

  // すでに処理済みならスキップ
  if (rankingSection.dataset.rankingBadged) return;
  rankingSection.dataset.rankingBadged = 'true';

  var cards = rankingSection.querySelectorAll('product-card');
  if (cards.length === 0) return;

  cards.forEach(function(card, index) {
    // すでにバッジがあれば削除してから再挿入
    var existing = card.querySelector('.ranking-card-badge');
    if (existing) existing.remove();

    var badge = document.createElement('span');
    badge.className = 'ranking-card-badge';
    badge.innerHTML = '<span class="ranking-card-badge__num">' + (index + 1) + '</span>';

    card.insertBefore(badge, card.firstChild);
  });
}

document.addEventListener('DOMContentLoaded', addRankingBadges);